import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import moment from "moment";
import Modal from "react-modal";
import GmapMultiple from "../../Analytics/Procurement/GmapMultiple";
import MapComponent from "./MapComponent";

const FarmerPlotMappingForm = (props) => {
  const [farmerNo, setFarmerNo] = useState("");
  const [farmerName, setFarmerName] = useState("");
  const [executiveName, setExecutiveName] = useState("");
  const [totalArea, setTotalArea] = useState("");
  const [plotList, setPlotList] = useState([]);

  const [plotCoordinateList, setPlotCoordinateList] = useState([]);
  const [coordinateList, setCoordinateList] = useState([]);
  const [markerList, setMarkerList] = useState([]);

  const { sendRequest: getFlotList } = useHttp();

  useEffect(() => {
    if (props.update) {
      const Id = props.update.farmerId || 0;

      getFlotList(
        {
          url: `/api/farmerPlotMapping/?orgId=${localStorage.getItem(
            "orgId"
          )}&farmerId=${Id}`,
        },
        (res) => {
          if (res) {
            console.log(res);

            setFarmerNo(res.farmerNo || "");
            setFarmerName(res.farmerName || "");
            setExecutiveName(res.fieldExecutiveName || "");
            setTotalArea(res.plotSizeInHa || "");
            setPlotList(res?.plotData);
          }
        }
      );
    }
  }, [props.update]);
  const { sendRequest: putPlot } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault(false);

    var data = "";
    if (props.update) {
      //   data = {
      //     registrationDate: moment(date).format("DD/MM/YYYY"),
      //     farmerId: farmerData?.farmerId || 0,
      //     farmerNo: farmerNo,
      //     farmerName: farmerName,
      //     gender: gender,
      //     dob: moment(dob).format("DD/MM/YYYY"),
      //     ageRange: ageRange,
      //     mobile: mobileNo,
      //     email: email,
      //     lga: lga,
      //     address: address,
      //     city: city,
      //     state: state,
      //     country: country,
      //     villageName: villageName,
      //     enrollmentPlace: enrollmentPlace,
      //     farmerEducation: farmerEducation,
      //     category: category,
      //     religion: castReligion,
      //     maritalStatus: maritalStatus,
      //     seasonId: seasonId,
      //     plotSizeInHa: plotSize,
      //     bvn: bvn,
      //     bankName: bankName,
      //     accountNumber: accountNumber,
      //     accountHolderName: accountHolderName,
      //     idProof: idProof,
      //     urlProfile: backImage,
      //     urlAttachment: idProofUrl,
      //     signatureAttachment: signature,
      //     createdBy: farmerData?.createdBy,
      //     fieldExecutiveId: farmerData?.fieldExecutiveId,
      //     regionId: farmerData?.regionId,
      //     empId: farmerData?.empId,
      //   };

      console.log(data);

      putPlot(
        {
          url: "/api/farmerEnrolment/",
          method: "PUT",
          body: data,
        },
        (data) => {
          toast.success(`Farmer Updated successfully`);
          props.addForm(false);
        }
      );
    }
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "50%",
      left: "60%",
      transform: "translate(-50%, -50%)",
      maxWidth: "100%",
      width: "730px", // Adjust the width as needed
      height: "550px",
      minHeight: "550px",
      overflow: "auto",
      //  border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [coordinates, setCoordinates] = useState([]);
  const { sendRequest: getPlotDetails } = useHttp();

  const formatDate = (date) => {
    const [day, month, year] = date?.split("/");
    return `${year}-${month}-${day}`; // returns the date in YYYY-MM-DD format
  };

  const openModal = (data) => {
    if (data) {
      console.log(data);

      setSelectedData(data);

      const parsedData = JSON.parse(data?.plotCoordinates);
      console.log(parsedData);

      setCoordinates(parsedData);
    }

    setIsModalOpen(true);
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Farmer Plot Mapping Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Farmer Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={farmerName}
                          onChange={(e) => setFarmerName(e.target.value)}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Farmer No</label>
                        <input
                          type="text"
                          className="form-control"
                          value={farmerNo}
                          onChange={(e) => setFarmerNo(e.target.value)}
                          readOnly
                        />
                      </div>{" "}
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Field Executive Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={executiveName}
                          readOnly
                          onChange={(e) => setExecutiveName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Total Area(Ha)</label>
                        <input
                          type="text"
                          className="form-control"
                          value={totalArea}
                          readOnly
                          onChange={(e) => setTotalArea(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Sr. No</th>
                          <th>Plot Name</th>
                          <th>Mapping Date</th>
                          <th>Plot Area(Ha)</th>
                          <th>Detail List</th>
                        </tr>
                      </thead>
                      <tbody>
                        {plotList &&
                          plotList.map((x, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{x.plotName}</td>
                              <td>{x.mappingDate}</td>
                              <td>{x.plotArea}</td>

                              <td>
                                <button
                                  type="button"
                                  onClick={() => openModal(x)}
                                  className="btn btn-sm btn-success"
                                >
                                  Add
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <div className="">
          <div className="container mt-1">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Plot Detail</h3>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  onClick={() => setIsModalOpen(false)}
                >
                  ×
                </button>
              </div>
              <div className="card-body">
                {selectedData && (
                  <form>
                    {/* Plot Details */}
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="mappingDate">Mapping Date</label>
                          <input
                            type="date"
                            id="mappingDate"
                            className="form-control"
                            value={formatDate(selectedData.mappingDate)}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="plotName">Plot Name</label>
                          <input
                            type="text"
                            id="plotName"
                            className="form-control"
                            placeholder="Enter Plot Name"
                            value={selectedData.plotName}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="farmLocation">Farm Location</label>
                          <input
                            type="text"
                            id="farmLocation"
                            className="form-control"
                            placeholder="Enter Farm Location"
                            value={selectedData.farmLocation}
                          />
                        </div>
                      </div>
                    </div>
                    {/* Additional Details */}
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="landMark">Land Mark</label>
                          <input
                            type="text"
                            id="landMark"
                            className="form-control"
                            placeholder="Enter Land Mark"
                            value={selectedData.landMark}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="irrigationSource">
                            Irrigation Source
                          </label>
                          <input
                            type="text"
                            id="irrigationSource"
                            className="form-control"
                            placeholder="Enter Irrigation Source"
                            value={selectedData.irrigationSource}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="landOwnership">Land Ownership</label>
                          <input
                            type="text"
                            id="landOwnership"
                            className="form-control"
                            placeholder="Enter Land Ownership"
                            value={selectedData.landOwnership}
                          />
                        </div>
                      </div>
                    </div>
                    {/* Soil Details */}
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="soilType">Soil Type</label>
                          <input
                            type="text"
                            id="soil type"
                            className="form-control"
                            placeholder="Enter Soil Type"
                            value={selectedData.soilType}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="soilTexture">Soil Texture</label>
                          <input
                            type="text"
                            id="soil texture"
                            className="form-control"
                            placeholder="Enter Soil Texture"
                            value={selectedData.soilTexture}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="area">Area</label>
                          <div className="input-group">
                            <input
                              type="number"
                              id="area"
                              className="form-control"
                              placeholder="Enter Area"
                              value={selectedData.plotArea}
                            />
                            <div className="input-group-append">
                              <span className="input-group-text">
                                {selectedData.plotAreaUnit}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Crop Details */}
                    <h6>
                      <strong>Crop Details</strong>
                    </h6>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Sr. No</th>
                            <th>Crop Type</th>
                            <th>Crop Name</th>
                            <th>Variety Name</th>
                            <th>Input Template</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedData?.cropList?.map((itm, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{itm.cropType}</td>
                              <td>{itm.cropName}</td>
                              <td>{itm.cropVariety}</td>
                              <td>{itm.templateName}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {/* Latitude/Longitude */}
                    <h6>
                      <strong>Plot Details</strong>
                    </h6>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Sr. No</th>
                            <th>Latitude</th>
                            <th>Longitude</th>
                          </tr>
                        </thead>
                        <tbody>
                          {coordinates?.map((coord, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{coord.latitude}</td>
                              <td>{coord.longitude}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div>
                      <MapComponent
                        coordinates={selectedData?.plotCoordinates}
                      />
                      <br/>
                      <h6>
                        <strong>Plot Photos</strong>
                      </h6>
                      <div className="row border p-2 rounded">
                        <div className="row">
                          {JSON.parse(selectedData?.plotPhotosUrls)?.map(
                            (url, index) => (
                              <div className="col-md-4" key={index}>
                                <img
                                  src={`${process.env.REACT_APP_FILE_URL}${url}`}
                                  alt={`Plot photo ${index + 1}`}
                                  width={200}
                                />
                              
                              </div> 
                            )
                          )}&nbsp;
                        </div>
                      </div>
                    </div>
                    {/* Submit Button */}
                    <div className="text-center">
                      <button type="submit" className="btn btn-primary">
                        Submit
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FarmerPlotMappingForm;
